var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangePasswordDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 20,
    viewBox: "0 0 20.002 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_30523",
    "data-name": "Path 30523",
    d: "M18190.621,21a4.624,4.624,0,0,1-4.619-4.619V5.62A4.622,4.622,0,0,1,18190.621,1h10.764A4.624,4.624,0,0,1,18206,5.62V16.382a4.627,4.627,0,0,1-4.619,4.619Zm-2.557-15.381V16.382a2.56,2.56,0,0,0,2.557,2.557h10.764a2.555,2.555,0,0,0,2.551-2.557V5.62a2.555,2.555,0,0,0-2.551-2.557h-10.764A2.56,2.56,0,0,0,18188.064,5.62Zm6.84,9,.459-2.48-1.891,1.7-1.18-2.057,2.346-.82-2.324-.766,1.086-1.963,1.979,1.66-.5-2.516h2.271l-.5,2.516,1.982-1.66,1.07,1.947-2.344.82,2.344.8-1.143,2.025-1.91-1.68.48,2.48Z",
    transform: "translate(-18186.002 -1.001)",
    fill: "#fff",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordDark);
export default __webpack_public_path__ + "static/media/ChangePasswordDark.4e9c3e0f8b7716ba314b694c26767a57.svg";
export { ForwardRef as ReactComponent };